import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { SITE_LOGO_URL } from '../lib/brand';
import SafeIcon from '../common/SafeIcon';

export default function Login() {
  const { login } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      console.error('Login failed:', err);
      setError(err.message || 'No se pudo iniciar sesión');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-4 bg-[#FAF9F6] relative overflow-hidden">
      {/* Back Button */}
      <Link 
        to="/" 
        className="absolute top-8 left-8 flex items-center gap-2 text-stone-400 hover:text-[#1B2A4E] transition-colors font-medium z-20"
      >
        <SafeIcon name="ArrowLeft" className="w-5 h-5" /> Volver
      </Link>

      {/* Background Graphics */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none sol-watermark" style={{backgroundSize: '800px'}}></div>
      
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#74ACDF] rounded-full blur-[100px] opacity-20"></div>
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#F6B40E] rounded-full blur-[100px] opacity-10"></div>

      <div className="w-full max-w-md bg-white rounded-[40px] shadow-2xl p-10 border border-stone-100 relative z-10">
        <div className="text-center mb-10">
          <img
            src={SITE_LOGO_URL}
            alt="Argentina Emprende"
            className="w-20 h-20 rounded-2xl object-cover shadow-xl mx-auto mb-6"
          />
          <h1 className="text-3xl font-editorial font-bold text-[#1B2A4E]">Argentina Emprende</h1>
          <p className="label-technical text-stone-400 mt-3">Comunidad en USA</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block label-technical text-stone-400 mb-2">Email</label>
            <input 
              type="email" 
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-5 py-4 rounded-2xl border border-stone-200 focus:ring-2 focus:ring-[#74ACDF]/50 bg-stone-50 focus:bg-white outline-none transition-all text-[#1B2A4E] font-medium"
              placeholder="tu@email.com"
            />
          </div>
          <div>
            <label className="block label-technical text-stone-400 mb-2">Contraseña</label>
            <input 
              type="password" 
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-5 py-4 rounded-2xl border border-stone-200 focus:ring-2 focus:ring-[#74ACDF]/50 bg-stone-50 focus:bg-white outline-none transition-all text-[#1B2A4E]"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p className="text-red-600 text-sm font-medium bg-red-50 rounded-xl px-4 py-3">{error}</p>
          )}

          <button 
            type="submit" 
            disabled={isLoading}
            className="w-full bg-[#1B2A4E] hover:bg-[#253969] text-white font-bold py-4 rounded-2xl transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-3 mt-8"
          >
            {isLoading ? <SafeIcon name="Loader" className="animate-spin w-6 h-6" /> : 'Ingresar a la Comunidad'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <Link to="/recuperar-password" className="text-sm font-medium text-[#74ACDF] hover:underline">
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <div className="mt-10 text-center text-sm font-medium text-stone-500 border-t border-stone-100 pt-8">
          ¿No tenés cuenta? <Link to="/registro" className="text-[#74ACDF] font-bold hover:underline">Solicitá una invitación</Link>
        </div>
      </div>
    </div>
  );
}
